import * as APPCONFIG from "../../src/config/app-config";
import auth from "./AuthAPI.js";
import Http from "./Http.js";

export const getUserDetailsById = (form) => {
  return auth({
    method: "post",
    url: `${APPCONFIG.API_URL}api/user/getUserDetailsById`,
    data: form,
    headers: Http.AUTH_HEADERS(),
  });
};

export const getUsersById = (form) => {
  return auth({
    method: "post",
    url: `${APPCONFIG.API_URL}api/user/getUsersById`,
    data: form,
    headers: Http.AUTH_HEADERS(),
  });
};

export const claimBonus = (form) => {
  return auth({
    method: "post",
    url: `${APPCONFIG.API_URL}api/user/claimBonus`,
    data: form,
    headers: Http.AUTH_HEADERS(),
  });
};

export const sendMoney = (form) => {
  return auth({
    method: "post",
    url: `${APPCONFIG.API_URL}api/user/sendMoney`,
    data: form,
    headers: Http.AUTH_HEADERS(),
  });
};

export const updatePasscode = (form) => {
  return auth({
    method: "post",
    url: `${APPCONFIG.API_URL}api/user/updatePasscode`,
    data: form,
    headers: Http.AUTH_HEADERS(),
  });
};

export const validatePasscode = (form) => {
  return auth({
    method: "post",
    url: `${APPCONFIG.API_URL}api/user/validatePasscode`,
    data: form,
    headers: Http.AUTH_HEADERS(),
  });
};

export const payNow = (form) => {
  return auth({
    method: "post",
    url: `${APPCONFIG.API_URL}api/user/payNow`,
    data: form,
    headers: Http.AUTH_HEADERS(),
  });
};

export const createOrUpdateAgentAndCustomer = (form) => {
  return auth({
    method: "post",
    url: `${APPCONFIG.API_URL}api/createOrUpdateAgentAndCustomer`,
    data: form,
    headers: Http.AUTH_MULTIPART_HEADERS(),
  });
};

/**
 * Filter users
 * @param {Object} form - Filter criteria
 */
export const filterUsers = (form) => {
  return auth({
    method: "post",
    url: `${APPCONFIG.API_URL}api/users/filter`,
    data: form,
    headers: Http.AUTH_HEADERS(),
  });
};

export const searchCustomers = (form) => {
  return auth({
    method: "post",
    url: `${APPCONFIG.API_URL}api/users/contact`,
    data: form,
    headers: Http.AUTH_HEADERS(),
  });
};

/**
 * Suspend a user
 * @param {Object} form - Should contain { id: userId }
 */
export const suspendUser = (form) => {
  return auth({
    method: "post",
    url: `${APPCONFIG.API_URL}api/users/suspend`,
    data: form,
    headers: Http.AUTH_HEADERS(),
  });
};

export const dashboardSummary = (form) => {
  return auth({
    method: "get",
    url: `${APPCONFIG.API_URL}auth/dashboard/summary`,
    data: form,
    headers: Http.AUTH_HEADERS(),
  });
};
